{
  "actions": {
    "add-filters": "Добавить фильтры",
    "clear-search": "Очистить поиск",
    "clear-filters": "Очистить фильтры",
    "select-fields": "Выберите поля"
  },
  "text": {
    "field-type": "Тип поля",
    "condition": "Условие",
    "operator": "Оператор",
    "value": "Значение"
  },
  "field-types": {
    "keyword": "Строка",
    "text": "Текст",
    "date": "Дата и время",
    "long": "Число (целое)",
    "integer": "Число (целое)",
    "short": "Число (целое)",
    "byte": "Число (целое)",
    "float": "Число (дробное)",
    "double": "Число (дробное)",
    "half_float": "Число (дробное)"
  },
  "dsl-blocks": {
    "must": {
      "label": "Обязательно",
      "description": "Должен совпадать со всеми фильтрами"
    },
    "should": {
      "label": "Желательно",
      "description": "Должен совпадать хотя бы с одним фильтром"
    },
    "must_not": {
      "label": "Исключить",
      "description": "Не должен совпадать ни с одним фильтром"
    },
    "filter": {
      "label": "Фильтр",
      "description": "Быстрое соответствие без подсчета релевантности"
    }
  },
  "filter-types": {
    "term": {
      "label": "Равно",
      "description": "Точное совпадение с одним значением",
      "placeholder": "Выберите значение"
    },
    "terms": {
      "label": "Одно из",
      "description": "Совпадение с любым из указанных значений",
      "placeholder": "Выберите значения"
    },
    "prefix": {
      "label": "Начиается с",
      "description": "Начинается с указанного текста",
      "placeholder": "Введите текст"
    },
    "range": {
      "label": "Диапазон",
      "description": "Входит в указанный диапазон",
      "placeholderStart": "Введите начальное значение",
      "placeholderEnd": "Введите конечное значение"
    },
    "exists": {
      "label": "Существует",
      "description": "Поле содержит любые данные"
    },
    "match": {
      "label": "Содержит слова",
      "description": "Содержит указанный текст (с учетом анализа)",
      "placeholder": "Введите текст"
    },
    "match_phrase": {
      "label": "Точная фраза",
      "description": "Содержит точную фразу подряд",
      "placeholder": "Введите текст"
    },
    "match_phrase_prefix": {
      "label": "Начало фразы",
      "description": "Начинается с точной фразы",
      "placeholder": "Введите текст"
    },
    "multi_match": {
      "label": "По нескольким полям",
      "description": "Ищет текст в нескольких полях сразу",
      "placeholder": "Введите текст"
    }
  }
}